import ScrollEffect from "./ScrollEffect";
import initSwiper from "./InitSwiper";

export function setImagesAndInitSlider() {
    document.querySelectorAll(".swiper-image.swiper-slide").forEach((swiperSlide) => {
        const mobileImage = swiperSlide.dataset.backgroundMobile;

        if (window.innerWidth <= 450 && mobileImage) {
            swiperSlide.style.backgroundImage = `url(${mobileImage})`;
        } else {
            swiperSlide.style.backgroundImage = `url(${swiperSlide.dataset.backgroundDesktop})`;
        }
    });

    initSwiper();
    ScrollEffect();
}
